import { makeStyles, tokens } from '@fluentui/react-components';

interface Props {
  source: 'AUTO' | 'M365' | 'ASCORA';
}

const useStyles = makeStyles({
  tag: {
    fontSize: '9px',
    fontWeight: 600,
    letterSpacing: '0.5px',
    color: tokens.colorNeutralForeground4,
    textTransform: 'uppercase',
    marginLeft: '6px',
    flexShrink: 0,
    fontFamily: 'inherit',
  },
});

/**
 * Small text-only tag indicating where a value came from. Replaces the v1.2.0
 * Fluent <Badge> approach which rendered as oversized blue pills inline with
 * text on iPhone. This is calmer, on-brand (no blue), and disappears on small
 * screens because it's just text.
 */
export function SourceTag({ source }: Props) {
  const styles = useStyles();
  return <span className={styles.tag}>{source}</span>;
}
